import React from "react";
import logo from "../../assets/img/logo.svg";
function NgLoading() {
  return (
    <div className="spinner-dots">
      <img src={logo} className="pb-10" alt="NG" />
      <span className="dot1"></span>
      <span className="dot2"></span>
      <span className="dot3"></span>
    </div>
  );
}
export default React.memo(NgLoading);
